export default __webpack_public_path__ + "static/media/wireless.739eb14b.svg";